import { TemplateType } from "@/domain";

// O produto opera somente com o módulo CHARGE. O antigo módulo CRM (cashback,
// templates de aniversário/pós-venda) foi descontinuado.
export type FidexaModulesType = "CHARGE";

export enum FidexaModulesEnum {
    ALL = "ALL",
    CHARGE = "CHARGE",
}

const moduleTemplateMap: Record<FidexaModulesType, TemplateType[]> = {
    CHARGE: [TemplateType.receivables],
};

function getTemplatesByModules(modules: FidexaModulesType[]): TemplateType[] {
    const templates = new Set<TemplateType>();

    modules.forEach((module) => {
        const mapped = moduleTemplateMap[module];
        if (mapped) mapped.forEach((t) => templates.add(t));
    });

    return Array.from(templates);
}

export const moduleTemplateUtils = {
    getTemplatesByModules
}
